import { Component, Vue, Emit, Watch } from 'vue-property-decorator';
import { LoginUser,NotificationList} from "@/types/Component";
import Popup from "@/components/Popup/Popup.vue";
import version from "../../App-version"
import NotificationModal from '@/components/Notification/NotificationModal/NotificationModal.vue';

@Component({
  components: {
    Popup,
    NotificationModal
  }
})

export default class Header extends Vue {
  private isOpen = false;
  private isExpenditureOpen = false;
  private isSalesResultOpen = false;
  private isHarvestResultOpen = false;
  private isWorkResultOpen = false;
  private isRecordOpen = false;
  private isManagementOpen = false;
  private isMasterMenuVisible = false;
  private isAccountMenuVisible = false;
  private isNotificationAdmin = false;
  private deleteTenantAlertPopup = false;
  private notifications: NotificationList[] = []
  notificationUnReadIconCount = 0
  /*テナント名の変更モーダル*/
  showChangeTenantPopup = false;
  private selectedTenant = {
    id:"",
    tenantName:"",
    subscriptionId:""
  };
  private showTenantName = '';
  private placeholder = "";
  get isAdmin(): boolean {
    this.notificationAdmin()
    return this.loginUser.role.find((r: string) => {
      return r === 'ADMIN'
    }) !== undefined;
  }

  get isContractAdmin(): boolean {
    return this.loginUser.role.find((r: string) => {
      return r === 'CONTRACT_ADMIN'
    }) !== undefined;
  }

   notificationAdmin() {
    this.isNotificationAdmin = this.loginUser.notificationWokerAdmin;
  }

  showNotificationModal=false;
  private siteVersion = version; //for version implementation
  private tenantVersion = "WEB"; //for version implementation
  private accountManagerUrl = process.env.VUE_APP_ACCOUNT_MANAGER_URL
  private subsriberDashboardUrl = `${this.accountManagerUrl}/subscriptions/${this.selectedTenant.subscriptionId}?type=general`
  
  get loginUser(): LoginUser {
    return this.$store.getters.loginUser;
  }

  mounted() {
    this.globalNaviOpenModal(4);
    this.$watch('$store.getters.loginUser', this.handleDefaultTenant, { immediate: true });    
    this.$watch('$store.getters.notificationCount', this.handleNotification, { immediate: true });  
    this.$watch('$store.getters.deleteTenantAlertPopUp', this.callTenantAlertPopup, { immediate: true });
  }
  
  callTenantAlertPopup(){
    if(this.$store.getters.deleteTenantAlertPopUp === true){
        this.deleteTenantAlertPopup = true
    }
  }

  handleDefaultTenant() {
    const defaultTenant = this.$store.getters.loginUser.tenantDetailsList.find(
      (item:any) => this.$store.getters.loginUser.webDefaultTenantID === item.id
    );
    if (defaultTenant) {
      this.showTenantName = defaultTenant.tenantName;
      this.selectedTenant = { id: defaultTenant.id, tenantName: defaultTenant.tenantName ,subscriptionId:defaultTenant.subscriptionId};
    } else {
      const firstTenant = this.$store.getters.loginUser.tenantDetailsList[0];
      this.showTenantName = firstTenant.tenantName;
      this.selectedTenant = { id: firstTenant.id, tenantName: firstTenant.tenantName ,subscriptionId:firstTenant.subscriptionId};
    }
    this.subsriberDashboardUrl = `${this.accountManagerUrl}/subscriptions/${this.selectedTenant.subscriptionId}?type=general`
    this.$store.dispatch('doUpdateLastTenantId', this.selectedTenant.id);
  }

  

  get parentPageName(): string {
    return this.$store.getters.parentPageName;
  }

  get currentPageName(): string {
    return this.$store.getters.currentPageName;
  }

  get parentPageNames(): string[] {
    return this.$store.getters.parentPageNames;
  }

  get parentPageClass(): string {
    switch(this.parentPageName) {
      case 'マスター設定':
        return 'is_master';
      case '集計・管理':
        return 'is_management';
      case 'カレンダー':
        return 'is_calendar';
      case '記録作成':
        return 'is_record';
      case 'ダッシュボード':
        return 'is_dashboard';
      case 'ユーザー一覧':
        return 'is_user';
      case 'お知らせ登録':
        return 'is-news'
      case 'お知らせ状況照会（契約者別）':
        return 'is-title-newssitu1'
      case 'お知らせ状況照会（お知らせ別）':
        return 'is-title-newssitu2'
      default:
        return 'is_master';
    }
  }

  globalNaviOpen(): void {
    this.isOpen = !this.isOpen;
  }

  globalNaviClose(): void {
    this.isOpen = false;
  }

  masterMenuClose(): void {
    this.isMasterMenuVisible = false;
  }

  logout(): void {
    localStorage.clear();
    location.href = "/oauth2/logout"
  }

  @Emit()
  cancel(){
    this.showChangeTenantPopup = false
  }
  
  private handleSelectChange(messageFlag:boolean){
    this.isAccountMenuVisible = false
    let result= false;
    setTimeout(()=>{
      if(messageFlag == false){
        result = window.confirm("テナントを変更します。よろしいですか。")
      }
      if(result || messageFlag == true){
        const params = {
          id:this.selectedTenant.id,
          kind:this.tenantVersion,
        }
        this.$apiClient.doRequest("post", "/profile", params).then((res) => {
          this.$store.dispatch('doUpdateIsTenantChanged', true);
          this.$store.dispatch('doUpdateLastTenantId', this.selectedTenant.id);
          return window.location.href=`/tenants/${this.selectedTenant.id}/`
        })
        .catch(() => {
          this.$toasted.error('変更に失敗しました。')
        })
      }else{
        this.$store.getters.loginUser.tenantDetailsList.map((item:any)=>{
          if(item.id == this.$store.getters.tenantId){
            this.showTenantName = item.tenantName
            this.selectedTenant = {id : item.id ,tenantName:item.tenantName ,subscriptionId :item.subscriptionId}
          }
        })
      }
    },100)
  }

  private updateTenantName(){
    if(this.showTenantName && this.showTenantName.trim() !== ''){
      const params = {
        id:this.selectedTenant.id,
        tenantName: this.showTenantName,
      }
      return this.$apiClient.doRequest("put", "/profile", params).then((res) => {
        this.$apiClient.getUserProfile()
        res.id ? this.$toasted.success('変更を保存しました。') : this.$toasted.error(res.statusMessage)
        this.cancel()
      })
      .catch(() => {
        this.$toasted.error('変更に失敗しました。')
      })
    }
    window.confirm("テナント名が必須です。")
  }
  
  globalNaviOpenModal(action: number): void {
    this.isOpen = false;
    switch (action) {
      case 0:
        this.isExpenditureOpen = !this.isExpenditureOpen;
        break
      case 1:
        this.isSalesResultOpen = !this.isSalesResultOpen;
        break
      case 2:
        this.isHarvestResultOpen = !this.isHarvestResultOpen;
        break
      case 3:
        this.isWorkResultOpen = !this.isWorkResultOpen;
        break
      case 4:
        this.isRecordOpen = !this.isRecordOpen;
        break
      case 5:
        this.isManagementOpen = !this.isManagementOpen;
        break
    }
  }

  handleNotification(){
     if(this.$store.getters.doUpdateDeleteTenantAlertPopUp == false){
        this.$apiClient.doRequest('get',`/notifications?is_important=false`).then(res => {
        this.notifications = res.notifications
        const notiticationUnReadCount = this.notifications.filter((notification:any) => !notification.isRead).length;
        this.$store.dispatch('doUpdateNotificationCount',notiticationUnReadCount);
        this.notificationUnReadIconCount = this.$store.getters.notificationCount;
        if(this.notifications.filter((notification:any) => notification.isImportant && !notification.isRead).length){
            this.openShowNotificationModal();
        }
      })
    }
  }
 
  openShowNotificationModal(): void {
    this.showNotificationModal = true
    this.isOpen= false
  }

  isPathActive(path:string) {
    return this.$route.path === path;
  }

  handleClick() {
    location.reload();
  }

  private async tenantSwitchLogout () {
    window.alert("ログアウトします。");
    return this.logout();
  }

}
